import { enableProdMode, importProvidersFrom, isDevMode, provideAppInitializer, inject } from '@angular/core';
import { environment } from './environments/environment';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { IonicModule, IonicRouteStrategy, ModalController } from '@ionic/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AdobeAnalyticsService, Logger, EncryptionKeyService, JetpackUtils } from '@pfizer/newton-jetpack-utils';
import { AppConfigProvider } from './app/app.config';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { IonicStorageModule } from '@ionic/storage-angular';
import { BootstrapService } from 'bootstrap.service';
import { LanguageService } from 'language.service';
import { MenuNavigationService } from 'app/services/menu-navigation.service';
import { UserStore } from 'user.store';
import { UtilsService } from 'utils.service';
import { StorageService } from 'storage.service';
import { SQLite } from '@awesome-cordova-plugins/sqlite/ngx';
import { NetworkService } from 'network.service';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { FirebaseService } from 'firebase.service';
import { RecallService } from 'recall.service';
import { provideServiceWorker } from '@angular/service-worker';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { DocumentViewer } from '@awesome-cordova-plugins/document-viewer/ngx';


if (environment.production) {
  enableProdMode();
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

function initApp(bootstrapService: BootstrapService) {
  return () => bootstrapService.init();
}

bootstrapApplication(AppComponent, {
  providers: [
    RecallService,
    FirebaseService,
    JetpackUtils,
    provideAppInitializer(() => {
      const initializerFn = (initApp)(inject(BootstrapService));

      return initializerFn();
    }),
    ModalController,
    NetworkService,
    SQLite,
    StorageService,
    EncryptionKeyService,
    UtilsService,
    UserStore,
    LanguageService,
    BootstrapService,
    MenuNavigationService,
    File,
    DocumentViewer,
    provideRouter(routes),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    importProvidersFrom(
      IonicModule.forRoot({
        backButtonText: '',
        mode: 'ios'
      })
    ),
    importProvidersFrom(HttpClientModule),
    importProvidersFrom(IonicStorageModule.forRoot({})),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en-US',
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        }
      })
    ),
    Logger,
    AppConfigProvider,
    TranslateService,
    AdobeAnalyticsService, provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
});
defineCustomElements(window);
